


























import {
  Vue, Component, Prop, Watch, Mixins, Emit, PropSync,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add, value,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase'
import md5 from 'md5'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import TaskStore from '../../store/modules/tasks'
import { db } from '../../firebase/init'
import { TaskType, CommentType, CustomerType } from '../../types'

const Tasks = collection<TaskType>('tasks')

@Component({
  components: {
  },
})
export default class SingleTask extends Mixins(MainMixin) {
  @Prop() data!:TaskType


  // @PropSync('show', { type: Boolean }) showDetails!: Boolean

  @Watch('completed')
  updateCompleted(newValue:boolean) {
    this.isComplete = newValue
  }

  isComplete = false

  newComment = ''

  showDetails = false

  test(x:any) {
    console.log('test')
  }

  async addComment() {
    if (!this.data.id) return false
    this.loading = true
    console.log('Adding Comment: ', this.newComment)
    const comment:CommentType = { user: this.$store.getters.uid, comment: this.newComment, created: new Date() }
    const result = await update(Tasks, this.data.id, [field('comments', value('arrayUnion', [comment]))])
    console.log('result is: ', result)
    this.newComment = ''
    this.$toast.success('Comment Added!')
    this.loading = false
    return true
  }
  // showDetails:boolean = false

  Task = getModule(TaskStore)

  loading = false

  isDisabled = false

  async changeComplete(x:boolean) {
    if (!this.data.id) return false
    this.isDisabled = true
    console.log(' complete changed to: ', x)
    const result = await x ? update(Tasks, this.data.id, {
      completed: new Date(), completedBy: this.$store.getters.uid,
    }) : update(Tasks, this.data.id, {
      completed: null, completedBy: '',
    })
    console.log('result is: ', result)
    this.isDisabled = false
    return result
  }

  mounted() {
    if (this.data.completed !== null) {
      this.isComplete = true
    }
  }
  // async sendMessage() {
  //   console.log('sending Message!')
  //   this.loading = true
  //   let ref:any
  //   if (this.messageType === 'manager') {
  //     ref = rdb.ref(`/locations/${this.location}/messages/${this.uid}`)
  //   }
  //   if (this.messageType === 'annoucement') {
  //     ref = rdb.ref(`locations/${this.location}/messages/announcements`)
  //   }
  //   if (this.messageType === 'group') {
  //     ref = rdb.ref(`locations/${this.location}/messages/group`)
  //   }
  //   if (ref) {
  //     console.log('here')
  //     try {
  //       const result = await ref.push({ created: new Date().toISOString(), user: this.uid, message: this.newMessage })
  //       console.log('result is: ', result)
  //     } catch (e) {
  //       console.log('error: ', e)
  //     }
  //     this.newMessage = ''
  //   }
  //   this.loading = false
  // }
}

